<template>
    <div v-if="!isFetching">
        <div
            v-if="!dataLength"
            class="box-body with-border clearfix"
        >
            <p v-if="!live">There are no Lists in the system.</p>
            <p v-else>There are no Live lists in the system.</p>
        </div>
        <div v-else>
            <div
                v-if="lists.total"
                class="box-body with-border clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <BadgeTotal
                    :value="lists.total"
                    color="gray"
                    :label="`${$t('total')}: `"
                />

                <pagination
                    :class="isDisabled()"
                    :data="lists"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Info</th>
                            <th>Tags</th>
                            <th>Price</th>
                            <th>Custom ID</th>
                            <th>Category</th>
                            <th>Statistic</th>
                            <th>Status</th>
                            <th class="text-right">Created At</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="list in lists.data"
                            :key="list.id"
                        >
                            <td>{{ list.id }}</td>
                            <td>
                                <ListItemsBadges :rows="infoRowData(list, countryTypes, live, isAdmin)" />
                            </td>
                            <td>
                                <ListItems :rows="list.tags" />
                            </td>
                            <td>{{ '$' + list.price_prepared_value }}</td>
                            <td>
                                <code v-if="list.custom_id">{{ list.custom_id }}</code>
                                <em
                                    v-else
                                    class="text-info"
                                    >None</em
                                >
                            </td>
                            <td>
                                <a
                                    v-if="!isUserOrPublisher && list.category"
                                    :href="getRoute(list.category.id, 'category')"
                                    >{{ list.category.name }}</a
                                >
                                <span v-else-if="list.category">{{ list.category.name }}</span>
                            </td>
                            <td>
                                <img
                                    v-show="!isLoadedStats"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <ListItemsBadges
                                    v-show="isLoadedStats"
                                    :rows="staticsRowData(list, live)"
                                    :sizable="true"
                                />
                            </td>
                            <td>
                                <img
                                    v-show="!isLoadedStatus"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <ListItemsBadges
                                    v-show="isLoadedStatus"
                                    :rows="statusRowData(list, live)"
                                    :sizable="true"
                                />
                            </td>
                            <td class="text-right">{{ list.created_at }}</td>
                            <td class="text-right">
                                <span v-if="!list.is_archived && !isUserOrPublisher">
                                    <ModalContent
                                        :id="list.id"
                                        :route="route"
                                        type="archive"
                                        @click="isShowModal = true"
                                        @modalEmitData="emittedModalData"
                                    />
                                    <ModalContent
                                        v-if="list.is_lookup_available"
                                        :id="list.id"
                                        :route="route"
                                        type="lookup"
                                        @click="isShowModal = true"
                                        @modalEmitData="emittedModalData"
                                    />
                                    <ModalContent
                                        v-if="list.is_lookup_resettable"
                                        :id="list.id"
                                        :route="route"
                                        type="lookupRest"
                                        @click="isShowModal = true"
                                        @modalEmitData="emittedModalData"
                                    />

                                    <a
                                        :href="getRoute(list.id, 'export')"
                                        class="btn btn-sm btn-warning"
                                        data-toggle="tooltip"
                                        title="All contacts"
                                    >
                                        <i class="fa fa-download"></i>
                                        <span class="sr-only">Export</span>
                                    </a>

                                    <a
                                        :href="getRoute(list.id, 'export') + '/30'"
                                        class="btn btn-sm btn-warning"
                                        data-toggle="tooltip"
                                        title="Clickers from the last 30 days"
                                    >
                                        <i class="fa fa-download"></i>
                                        <span class="sr-only">30-day clickers</span>
                                    </a>

                                    <a
                                        :href="getRoute(list.id, 'export') + '/60'"
                                        class="btn btn-sm btn-warning"
                                        data-toggle="tooltip"
                                        title="Clickers from the last 60 days"
                                    >
                                        <i class="fa fa-download"></i>
                                        <span class="sr-only">60-day clickers</span>
                                    </a>

                                    <a
                                        :href="getRoute(list.id, 'edit')"
                                        class="btn btn-sm btn-primary"
                                    >
                                        <i class="fa fa-edit"></i>
                                        <span class="sr-only">Edit</span>
                                    </a>
                                </span>
                                <a
                                    :href="getRoute(list.id, 'show')"
                                    class="btn btn-sm btn-info"
                                >
                                    <i class="fa fa-eye"></i>
                                    <span class="sr-only">Show</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div
                v-if="lists.total"
                class="box-footer clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="lists"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
            <main-modal-form
                v-if="isShowModal"
                :modal="emittedModalValues"
                @close="isShowModal = false"
                @updateData="modalData($event)"
            />
        </div>
    </div>
    <!-- /.box-body -->
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ListItemsBadges from '../../subcomponents/ListItemsBadges';
import ListItems from '../../subcomponents/ListItems';
import ModalContent from '../../subcomponents/modals-content/ModalListsContent';

export default {
    components: {
        BadgeTotal,
        ListItemsBadges,
        ListItems,
        ModalContent,
    },
    props: {
        route: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            lists: {},
            stats: {},
            status: {},
            ids: [],
            countryTypes: [],
            isFetching: true,
            isLoadedStatus: false,
            isLoadedStats: false,
            live: this.$attrs.live,
            isAdmin: false,
            isUserOrPublisher: true,
            pageNumber: this.$route.query.page,
            isShowModal: false,
            disablePagination: true,
            emittedModalValues: {},
            lookupStatusTimeout: 0,
        };
    },
    computed: {
        dataLength: function () {
            return this.lists.data.length;
        },
        filter: function () {
            let filter = '';

            if (this.$route.query['filter[dates]']) {
                filter += '&' + encodeURI('filter[dates]=' + this.$route.query['filter[dates]']);
            }

            if (this.$route.query['filter[ids]']) {
                filter += '&' + encodeURI('filter[ids]=' + this.$route.query['filter[ids]']);
            }

            return filter;
        },
    },
    watch: {
        filter: function () {
            this.isLoaded = false;

            if (this.$route.query['filter[ids]']) {
                this.getData(this.pageNumber);
            } else {
                this.getStatus(this.ids);
            }
        },
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    beforeDestroy() {
        clearTimeout(this.lookupStatusTimeout);
    },
    methods: {
        emittedModalData(value) {
            this.emittedModalValues = value;
        },
        modalData: function (e) {
            this.isShowModal = false;
            _.merge(_.keyBy(this.lists.data, 'id'), _.keyBy({ 0: e }, 'id'));
            this.getLookupProgress();
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            clearTimeout(this.lookupStatusTimeout);

            let query = '?page=' + page;

            if (this.$route.query['filter[ids]']) {
                query += '&' + encodeURI('filter[ids]=' + this.$route.query['filter[ids]']);
            }

            this.disablePagination = true;
            this.isLoadedStatus = false;
            this.isLoadedStats = false;

            axios.get(this.$route.path + '/data' + query).then((response) => {
                if (String(page) !== String(this.$route.query.page)) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { page: String(page) }) });
                }

                if (page > response.data.lists.last_page) {
                    return this.getData();
                }

                this.lists = response.data.lists;
                this.countryTypes = response.data.countryTypes;
                this.isAdmin = response.data.isAdmin;
                this.isUserOrPublisher = response.data.isUserOrPublisher;
                this.ids = response.data.ids;
                this.isFetching = false;

                if (this.ids.length) {
                    this.getStats(this.ids);
                    this.getStatus(this.ids);
                    this.getLookupProgress();
                }
            });
        },
        getStats(ids) {
            this.isLoadedStats = false;
            axios.get(this.$route.path + '/statics?ids=' + ids).then((response) => {
                this.stats = response.data.stats;
                this.disablePagination = !this.isLoadedStatus;
                let sort = _.merge(_.keyBy(this.lists.data, 'id'), _.keyBy(this.stats, 'id'));
                this.lists.data = _.orderBy(sort, ['id'], ['desc']);
                this.isLoadedStats = true;
            });
        },
        getStatus(ids) {
            this.isLoadedStatus = false;
            axios.get(this.$route.path + '/status?ids=' + ids + this.filter).then((response) => {
                this.status = response.data.status;
                this.disablePagination = !this.isLoadedStats;
                let sort = _.merge(_.keyBy(this.lists.data, 'id'), _.keyBy(this.status, 'id'));
                this.lists.data = _.orderBy(sort, ['id'], ['desc']);
                this.isLoadedStatus = true;
            });
        },
        getLookupProgress: function () {
            clearTimeout(this.lookupStatusTimeout);

            if (this.live) {
                return;
            }

            const ids = this.lists.data.filter((list) => this.isLookupInProgress(list)).map((list) => list.id);

            if (!ids.length) {
                return;
            }

            axios
                .get('/lists/lookup-progress?ids=' + ids)
                .then((response) => {
                    response.data.lookupProgress.forEach((lookupProgress) => {
                        const list = this.lists.data.find((list) => list.id === lookupProgress.id);

                        if (list) {
                            this.$set(list, 'status_lookup', lookupProgress.status_lookup);
                            this.$set(list, 'status_lookup_prepared_value', lookupProgress.status_lookup_prepared_value);
                            this.$set(list, 'status_lookup_color', lookupProgress.status_lookup_color);
                            this.$set(list, 'lookup_progress', lookupProgress.lookup_progress);
                        }
                    });
                })
                .finally(() => {
                    this.checkLookupProgress();
                });
        },
        checkLookupProgress: function () {
            const isLookupInProgress = !!this.lists.data.find((list) => this.isLookupInProgress(list));

            clearTimeout(this.lookupStatusTimeout);

            if (isLookupInProgress) {
                this.lookupStatusTimeout = setTimeout(() => {
                    this.getLookupProgress();
                }, 5000);
            }
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
        isLookupInProgress: function (list) {
            return list.status_lookup === 'PROCESS' || list.status_lookup === 'WAITING';
        },
        infoRowData: function (list, countryTypes, live, isAdmin) {
            let rows = [
                {
                    name: 'Name:',
                    component: 'ValueEmpty',
                    items: [{ value: list.name }],
                },
                {
                    name: 'Country Type:',
                    component: 'ValueEmpty',
                    items: [{ value: list.country_type_id ? countryTypes[list.country_type_id] : null }],
                },
            ];

            if (live) {
                rows.push(
                    {
                        name: 'Fallback Amount',
                        component: 'BadgeTotal',
                        items: [{ value: list.fallback_amount, color: 'gray' }],
                    },
                    {
                        name: 'Override Deduplication',
                        component: 'ValueYesNo',
                        items: [{ value: list.no_deduplication }],
                    }
                );
                isAdmin &&
                    rows.push({
                        name: 'Auth',
                        component: 'ValueYesNo',
                        items: [{ value: list.auth_enabled }],
                    });
            } else {
                rows.push(
                    {
                        name: 'File:',
                        component: 'ValueEmpty',
                        items: [{ value: list.file ? list.file.original_name.slice(0, 25) : null, textNone: 'Lost' }],
                    },
                    {
                        name: 'Override Deduplication:',
                        component: 'ValueYesNo',
                        items: [{ value: list && list.file && list.file.override ? list.file.override : false }],
                    }
                );
            }

            return rows;
        },
        staticsRowData: function (list, live) {
            let rows = [
                {
                    name: 'Campaigns',
                    component: 'BadgeTotal',
                    items: [{ value: list.campaigns_count, color: 'gray' }],
                },
                {
                    name: 'Messages',
                    component: 'BadgeTotal',
                    items: [
                        { value: list.messages_count, title: 'Total', color: 'gray' },
                        { value: list.messages_sent, title: 'Sent', color: 'green' },
                        { value: list.messages_failed, title: 'Failed', color: 'red' },
                        { value: list.messages_blacklisted, title: 'Blacklisted', color: 'black' },
                    ],
                },
                {
                    name: 'Clicks',
                    component: 'BadgeTotal',
                    items: [
                        { value: list.percentage + '%', title: 'Percentage', color: 'light-blue' },
                        { value: list.clicks_count, title: 'Amount', color: 'aqua-active' },
                    ],
                },
                {
                    name: 'Revenue',
                    component: 'BadgeTotal',
                    items: [
                        { value: '$' + list.revenues_prepared_value, title: 'Amount', color: 'light-blue' },
                        { value: list.revenues_count, title: 'Count', color: 'aqua-active' },
                    ],
                },
                {
                    name: 'eCPM/EPC',
                    component: 'BadgeTotal',
                    items: [
                        { value: list.ecpm_prepared_value, title: 'eCPM', color: 'light-blue' },
                        { value: list.epc_prepared_value, title: 'epc', color: 'aqua-active' },
                    ],
                },
                {
                    name: 'Unsubscribes',
                    component: 'BadgeTotal',
                    items: [
                        { value: list.unsubscribes_percent + '%', title: 'Percentage', color: 'light-blue' },
                        { value: list.unsubscribes_count, title: 'Count', color: 'aqua-active' },
                    ],
                }
            ];

            live &&
                rows.push({
                    name: 'Feedbacks',
                    component: 'BadgeTotal',
                    items: [{ value: list.feedbacks_count, color: 'gray' }],
                });

            return rows;
        },
        statusRowData: function (list, live) {
            let rows = [
                {
                    name: 'Active',
                    component: 'ValueYesNo',
                    items: [{ value: list.active }],
                },
                {
                    name: 'Status',
                    component: 'BadgeTotal',
                    items: [{ value: list.status_prepared_value, color: list.status_color }],
                },
                {
                    name: 'Lookup',
                    component: 'EmptyBadge',
                    items: [{ value: list.status_lookup ? list.status_lookup_prepared_value : null, color: list.status_lookup_color }],
                    progress: !live && this.isLookupInProgress(list) ? list.lookup_progress || 0 : null,
                },
            ];
            !live &&
                rows.push({
                    name: 'Parsed',
                    component: 'BadgeTotal',
                    items: [{ value: list.has_file ? (list.file.rows_total !== null && list.file.rows_total !== undefined ? list.file.rows_total : list.file.rows_parsed) : 0, color: 'gray' }],
                });
            rows.push({
                name: 'Contacts',
                component: 'BadgeTotal',
                items: [
                    { value: list.contacts_count || 0, title: 'Total', color: 'gray' },
                    { value: list.contacts_active || 0, title: 'Active', color: 'green' },
                    { value: list.contacts_inactive || 0, title: 'Inactive', color: 'red' },
                ],
            });
            return rows;
        },
    },
};
</script>
